import BaseResource from '@/lib/data/resource/BaseResource'

export default class RiskDebtInterestExpenseVariabilitySensitivityResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.Title = payload?.label || ''
    this.Value = payload?.value || ''
  }

  /* PROPERTIES */

  /* METHODS */
}
